import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/PORTTheme";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EventNoteIcon from "@mui/icons-material/EventNote";
import NoteIcon from "@mui/icons-material/Note";
import DescriptionIcon from "@mui/icons-material/Description";
import CategoryIcon from "@mui/icons-material/Category";
import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";

function PORTMenu() {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/portfolio",
            label: "My Portfolio",
            icon: (
                <DashboardIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/portfolio/pdps",
            label: "PDP",
            icon: (
                <FactCheckIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/portfolio/developmentneeds",
            label: "Development needs",
            icon: (
                <AutoGraphIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/portfolio/activities",
            label: "Activities",
            icon: (
                <EventNoteIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
        {
            path: "/portfolio/notes",
            label: "Notes",
            icon: <NoteIcon sx={{ color: ThisTheme.palette.primary.main }} />,
        },
        {
            path: "/portfolio/resources",
            label: "Resources",
            icon: (
                <DescriptionIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/portfolio/qualifications",
            label: "Qualifications",
            icon: (
                <HistoryEduIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/portfolio/categories",
            label: "Categories",
            icon: (
                <CategoryIcon sx={{ color: ThisTheme.palette.primary.main }} />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="Portfolio menu"
            data-cy="menu_port"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <SourceOutlinedIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Portfolio" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav" disablePadding>
                    {menuItems.map(({ path, icon, label }) => (
                        <ListItem
                            key={path}
                            component={Link}
                            to={path}
                            disablePadding
                        >
                            <ListItemButton className="nested">
                                <ListItemIcon>{icon}</ListItemIcon>
                                <ListItemText>{label}</ListItemText>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </List>
    );
}

export default PORTMenu;
